import { theme } from "../Styles/theme";

const ShoppingCartIcon = ({ style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      width="100%"
      viewBox="0 0 20 20"
      style={style}
    >
      <path
        d="m18 11.2 2-8c.1-.3 0-.6-.2-.9-.2-.2-.5-.3-.8-.3h-13.8l-.2-1.1c-.1-.5-.5-.9-1-.9h-3c-.6 0-1 .4-1 1s.4 1 1 1h2.1l1.7 12.2c-1 .5-1.8 1.5-1.8 2.8 0 1.7 1.3 3 3 3s3-1.3 3-3c0-.4-.1-.7-.2-1h4.4c-.1.3-.2.6-.2 1 0 1.7 1.3 3 3 3s3-1.3 3-3-1.3-3-3-3h-9.1l-.3-2h10.4c.5 0 .9-.3 1-.8zm-11 5.8c0 .6-.4 1-1 1s-1-.4-1-1 .4-1 1-1c.6 0 1 .4 1 1zm9 1c-.6 0-1-.4-1-1s.4-1 1-1c.6 0 1 .4 1 1s-.4 1-1 1zm-9.7-8-.9-6h12.3l-1.5 6z"
        fill={`${theme.main}`}
      />
    </svg>
  );
};

export default ShoppingCartIcon;
